export default "__VITE_ASSET__BIXOLX$X__"